<template>

	<div id="goal-progress" v-cloak v-if="exercise_goal_number || recipe_goal_number">

		<div class="title" v-if="showTitle">My goals</div>

		<div id="chart-wrapper">

			<div id="goal-exercise-chart-wrapper" v-show="exercise_goal_number">

				<vue-svg-gauge v-bind:class="{complete: exercise_goal_complete}" id="goal-exercise-chart" :innerRadius="80" :start-angle="0" :end-angle="360" :value="exercise_percentage" :min="0" :max="1" :separator-step="0" :scale-interval="0" :baseColor="'#FCFCFC'" :gaugeColor="'#D1ECE4'">

					<img class="icon" v-bind:src="exercise_icon" alt>

				</vue-svg-gauge>

				<div class="manual-tally-buttons">

					<button v-if="showButtons" @click="update_tally('exercise', true)" v-bind:disabled="thinking" class="vue-btn">-</button>
					<button v-if="showButtons" @click="update_tally('exercise', false)" v-bind:disabled="thinking" class="vue-btn">+</button>

				</div>

				<div class="completed-text">{{exercise_text}}</div>

			</div>

			<div id="goal-recipe-chart-wrapper" v-show="recipe_goal_number">

				<vue-svg-gauge v-bind:class="{complete: recipe_goal_complete}" id="goal-recipe-chart" :innerRadius="80" :start-angle="0" :end-angle="360" :value="recipe_percentage" :min="0" :max="1" :separator-step="0" :scale-interval="0" :baseColor="'#FCFCFC'" :gaugeColor="'#D1ECE4'">

					<img class="icon" v-bind:src="recipe_icon" alt>

				</vue-svg-gauge>

				<div class="manual-tally-buttons">

					<button v-if="showButtons" @click="update_tally('recipe', true)" v-bind:disabled="thinking" class="vue-btn">-</button>
					<button v-if="showButtons" @click="update_tally('recipe', false)" v-bind:disabled="thinking" class="vue-btn">+</button>

				</div>

				<div class="completed-text">{{recipe_text}}</div>

			</div>

		</div>

	</div>

</template>


<script>
	export default {

		name: 'goal-progress',

		props: {

			delay: {

				default: 0,
				type: Number,

			},

			showButtons: {

				default: false,
				type: Boolean,

			},
			showTitle: {

				default: false,
				type: Boolean,

			}

		},

		data() {

			return {

				thinking: true,
				goals: false,
				goal_tally: false,
				week_number: false,
				recipe_chart: false,
				exercise_chart: false,
				exercise_icon: coreVariables.stylesheetUri + '/images/icons/exercise-goal-icon.svg',
				recipe_icon: coreVariables.stylesheetUri + '/images/icons/recipe-goal-icon.svg',
				goals_retrieved: false,
				no_goals_set: false,

			}

		},

		computed: {

			current_recipe_goal_tally() {

				if (coreHelpers.getNested(this, 'goal_tally', this.week_number, 'recipe')) {

					return this.goal_tally[this.week_number]['recipe'];

				}

				return 0;

			},

			current_exercise_goal_tally() {

				if (coreHelpers.getNested(this, 'goal_tally', this.week_number, 'exercise')) {

					return this.goal_tally[this.week_number]['exercise'];

				}

				return 0;

			},

			exercise_goal_number() {

				if (coreHelpers.getNested(this, 'goals', 'exercise_goal')) {

					return Object.values(this.goals['exercise_goal']).filter((value) => value === 'true').length;

				}

				return 0;

			},

			recipe_goal_number() {

				if (coreHelpers.getNested(this, 'goals', 'recipe_goal')) {

					return parseInt(this.goals.recipe_goal);

				}

				return 0;

			},

			recipe_percentage() {

				if (coreHelpers.getNested(this, 'goals', 'recipe_goal') && coreHelpers.getNested(this, 'current_recipe_goal_tally')) {

					let percentage = parseInt(this.current_recipe_goal_tally) / parseInt(this.goals['recipe_goal']);

					if (percentage > 1) {

						percentage = 1;

					}

					return percentage;

				} else {

					return 0;
				}

			},

			exercise_percentage() {

				if (coreHelpers.getNested(this, 'goals') && coreHelpers.getNested(this, 'current_exercise_goal_tally')) {

					let percentage = parseInt(this.current_exercise_goal_tally) / parseInt(this.exercise_goal_number);

					if (percentage > 1) {

						percentage = 1;

					}

					return percentage;

				} else {

					return 0;
				}

			},

			recipe_goal_complete() {

				if (this.recipe_percentage === 1) {

					return true;
				}

				return false;

			},

			exercise_goal_complete() {

				if (this.exercise_percentage === 1) {

					return true;
				}

				return false;

			},

			recipe_text() {

				if (!this.goals_retrieved) {

					return 'Calculating';

				} else if (coreHelpers.getNested(this, 'goals', 'recipe_goal') && this.current_recipe_goal_tally >= 0) {

					return this.current_recipe_goal_tally + ' / ' + this.goals['recipe_goal'] + ' completed';

				} else if (this.no_goals_set || typeof(this.goals) === 'undefined') {

					return 'No goal set'

				}

			},

			exercise_text() {

				if (!this.goals_retrieved) {

					return 'Calculating';

				} else if (this.current_recipe_goal_tally >= 0 && this.exercise_goal_number) {

					return this.current_exercise_goal_tally + ' / ' + this.exercise_goal_number + ' completed';

				} else if (this.no_goals_set || typeof(this.goals) === 'undefined') {

					return 'No goal set'

				}

			},

		},

		mounted() {

			setTimeout(() => {

				this.get_progress();

			}, this.delay);

		},

		methods: {

			get_progress() {

				this.thinking = true;

				window.coreHelpers.ajax.call(this, 'POST', 'lc_get_goal_progress', {

					date: window.DateTime.local().toFormat('ddMMyyyy'),

				}, function(res) {

					console.log('LC: got goal progress', res);
					this.goals = coreHelpers.getNested(res, 'data', 'goals', 'goals');
					this.goal_tally = coreHelpers.getNested(res, 'data', 'goals', 'goal_tally');
					this.week_number = coreHelpers.getNested(res, 'data', 'week_number');
					this.thinking = false;
					this.goals_retrieved = true;

					if ((coreHelpers.getNested(this, 'goals', 'no_goals') && this.goals.no_goals === 'true') || !this.goals) {

						let wrapper = document.getElementById('goal-progress-wrapper');

						if (wrapper) {

							document.getElementById('goal-progress-wrapper').classList.add('no-goals');

						}

					}

				}, function(res) {

					this.thinking = false;
					console.log('LC: error getting goal progress', res);

				});

			},

			/**
			 * @param type 'recipe' | 'exercise'
			 */
			update_tally(type, decrease = false) {

				this.thinking = true;

				window.coreHelpers.ajax.call(this, 'POST', 'lc_update_goal_tally', {

					'date': window.DateTime.local().toFormat('ddMMyyyy'),
					'type': type,
					'decrease': decrease,

				}, function(res) {

					if (res.success) {

						this.thinking = false;

						console.log('LC: goal updated', res);

						//update goal progress if on the btb page
						if (coreHelpers.getNested(window, 'vueBTBHome', '$refs', 'goal-progress')) {

							const updatedTally = coreHelpers.getNested(res, 'data', 'updated_data', ':goal_tally');
							window.vueBTBHome.$refs['goal-progress']['goal_tally'] = updatedTally;

						}

						if (coreHelpers.getNested(res, 'data', 'params', 'recipe_goal_complete')) {

							window.vueMessages.addMessage('You’re kicking goals! How delicious... ', false, false, 'goal-achieved');

							window.lcGA('Goals', 'Complete', 'Recipe goal', coreVariables.userId);

						} else if (coreHelpers.getNested(res, 'data', 'params', 'exercise_goal_complete')) {

							window.vueMessages.addMessage('You’re making such good progress! Enjoy those post-workout endorphins.', false, false, 'goal-achieved');

							window.lcGA('Goals', 'Complete', 'Exercise goal', coreVariables.userId);

						}

					}

				}, function(res) {

					this.thinking = false;

					console.log('LC: could not update tally');

				});

			},

		}
	}
</script>